var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('display-schedule',{attrs:{"fields":_vm.fields,"variant-options":_vm.variantOptions,"items":_vm.items,"sticky-header":_vm.stickyHeader}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }